import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img, {
  GatsbyImageWithIEPolyfillProps,
} from 'gatsby-image/withIEPolyfill';

interface Props {
  path: string;
  alt: string;
  objectFit?: GatsbyImageWithIEPolyfillProps['objectFit'];
  objectPosition?: GatsbyImageWithIEPolyfillProps['objectPosition'];
  className?: string;
}

const Image = (props: Props) => (
  <StaticQuery
    query={graphql`
      query {
        image: allFile {
          edges {
            node {
              relativePath
              name
              publicURL
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.image.edges.find((n: any) => {
        return n.node.relativePath.includes(props.path);
      });
      if (!image) return;
      // if (image.node.childImageSharp) {
      //   return (
      //     <Img
      //       fluid={image.node.childImageSharp.fluid}
      //       className={props.className || ''}
      //       objectFit={props.objectFit}
      //       objectPosition={props.objectPosition}
      //       alt={props.alt}
      //     />
      //   );
      // }
      return (
        <img
          src={image.node.publicURL}
          className={props.className || ''}
          alt={props.alt}
        />
      );
    }}
  />
);

export default Image;
